import React, { Fragment } from "react";
import PropTypes from "prop-types";

import TextInput from "components/shared/Inputs/TextInput";
import LoginPage from "components/Login/LoginPage";

import {
  ENABLE_LOGIN_TOPBAR,
  USE_LOGIN_HOME_TEMPLATE_2,
  ENABLE_LOGIN_HOME,
  PRIVACY_PAGE_LINK
} from "config";
import localize from "lang/localize";

import "./Login.css";

const propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  handlePasswordChange: PropTypes.func.isRequired,
  handleUpdateMarketingConsent: PropTypes.func.isRequired,
  handleUpdatePrivacyAgreed: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handlePrivacySubmit: PropTypes.func.isRequired,
  showPrivacyAgreement: PropTypes.bool,
  marketingConsent: PropTypes.bool,
  privacyAgreed: PropTypes.bool.isRequired,
  projectId: PropTypes.number,
  topbarlessBackButtonRoute: PropTypes.string,
  language: PropTypes.string,
  /* Guest Login Dialog */
  guestEnabled: PropTypes.bool.isRequired,
  showGuestLoginDialog: PropTypes.bool.isRequired,
  handleOpenGuestLoginDialog: PropTypes.func.isRequired,
  handleCloseGuestLoginDialog: PropTypes.func.isRequired,
  /* Show Recaptcha */
  userRecaptchaActivate: PropTypes.bool,
  /* OAuth */
  responseFacebook: PropTypes.func.isRequired,
  responseFacebookError: PropTypes.func.isRequired,
  responseGoogle: PropTypes.func.isRequired,
  responseGoogleError: PropTypes.func.isRequired,
  /* Loading indicators */
  isSubmitLoading: PropTypes.bool,
  setSubmitLoading: PropTypes.func,
  /* Custom: guest nickname handlers */
  handleGuestNicknameChange: PropTypes.func,
  handleNicknameSubmit: PropTypes.func
};

class CustomLoginPage extends LoginPage {
  /* Custom: new function */
  handleGuestNicknameKeyPress = event => {
    if (event.key === "Enter") {
      this.props.handleNicknameSubmit(event);
    }
  };

  /* Custom: no dialog, guest login form directly on login page */
  renderGuestLoginSection() {
    if (
      this.props.projectId &&
      this.props.guestEnabled &&
      ((ENABLE_LOGIN_HOME && !USE_LOGIN_HOME_TEMPLATE_2) || !ENABLE_LOGIN_HOME)
    ) {
      return (
        <Fragment>
          <div className="pure-g">
            <div className="pure-u-1-12" />
            <div className="pure-u-5-6">
              <h3 className="text-align-center uppercase bottommargin-10">
                {localize("nickname_label", this.props.language)}
              </h3>
              <form className="pure-form bottommargin-10">
                <TextInput
                  id="nicknameInput"
                  onChange={this.props.handleGuestNicknameChange}
                  onKeyPress={this.handleGuestNicknameKeyPress}
                  placeholder={localize(
                    "nickname_placeholder",
                    this.props.language
                  )}
                />
              </form>
              <button
                className="button button-login-guest fullwidth cta capitalize"
                onClick={this.props.handleNicknameSubmit}
              >
                {localize("button_quest_start", this.props.language)}
              </button>
            </div>
            <div className="pure-u-1-12" />
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  /* Custom: custom design, only guest login */
  render() {
    if (
      /* checking type is important: showPrivacyAgreement is initialised as null */
      typeof this.props.showPrivacyAgreement === "boolean" &&
      this.props.showPrivacyAgreement === true
    ) {
      return (
        <div className="login-register-container container verticalpadding">
          {this.renderTopbarlessBackButton()}
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-2-24 pure-u-sm-3-24" />
            <div className="pure-u-20-24 pure-u-sm-18-24">
              <h1
                className="uppercase text-align-center bottommargin"
                dangerouslySetInnerHTML={{
                  __html: localize(
                    "fairprice_login_header",
                    this.props.language
                  ).format(
                    "<span class='text-fairprice-red'>" +
                      localize("singapore_text", this.props.language) +
                      "</span>"
                  )
                }}
              />
              <p className="bottommargin-30 text-align-center font-weight-medium">
                {localize("fairprice_login_subtitle", this.props.language)}
              </p>
            </div>
            <div className="pure-u-2-24 pure-u-sm-3-24" />
          </div>
          <div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
              <h5>
                {localize(
                  "login_view_privacy_policy_updated_title",
                  this.props.language
                )}
              </h5>
              <p>
                {localize("login_agree_to_new_terms_text", this.props.language)}
              </p>
              <div className="bottommargin-30">
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdatePrivacyAgreed}
                    checked={this.props.privacyAgreed}
                  />{" "}
                  {localize(
                    "register_agree_to_gametize_text",
                    this.props.language
                  )}
                  <a
                    className="link default"
                    href={PRIVACY_PAGE_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {localize(
                      "register_privacy_policy_text",
                      this.props.language
                    )}
                  </a>
                  .
                </p>
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdateMarketingConsent}
                    checked={this.props.marketingConsent}
                  />{" "}
                  {localize(
                    "register_marketing_communications_text",
                    this.props.language
                  )}
                </p>
              </div>
              <div className="pure-g bottommargin">
                <div className="pure-u-11-24 pure-u-sm-14-24 pure-u-lg-2-3" />
                <div className="pure-u-13-24 pure-u-sm-10-24 pure-u-lg-1-3">
                  <button
                    className={
                      "button fullwidth " +
                      (this.props.privacyAgreed ? "cta" : "inactive")
                    }
                    onClick={this.props.handlePrivacySubmit}
                    disabled={!this.props.privacyAgreed}
                  >
                    {localize("button_quest_continue", this.props.language)}
                  </button>
                </div>
              </div>
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    } else {
      return (
        <div className="login-register-container container verticalpadding flex flex-direction-column justify-content-center">
          {this.renderTopbarlessBackButton()}
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-2-24 pure-u-sm-3-24" />
            <div className="pure-u-20-24 pure-u-sm-18-24">
              <h1
                className="uppercase text-align-center bottommargin"
                dangerouslySetInnerHTML={{
                  __html: localize(
                    "fairprice_login_header",
                    this.props.language
                  ).format(
                    "<span class='text-fairprice-red'>" +
                      localize("singapore_text", this.props.language) +
                      "</span>"
                  )
                }}
              />
              <p className="bottommargin-30 text-align-center font-weight-medium">
                {localize("fairprice_login_subtitle", this.props.language)}
              </p>
            </div>
            <div className="pure-u-2-24 pure-u-sm-3-24" />
          </div>
          <div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
              {/* Custom for NTUC: Simplify codes here and avoid nested <form> */}
              {this.renderGuestLoginSection()}
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    }
  }
}

CustomLoginPage.propTypes = propTypes;

export default CustomLoginPage;
